import { Card, Flex } from '@grupoboticario/flora-react';
import { useParams } from 'react-router-dom';

import { Divider, Skeleton, Card as CardBase, ResponsiveFloraTypography } from 'components';
import { useOrderDetail } from 'hooks';

import { StatusItem, TrackingSteps } from './components';
import Styles from './Tracking.styles';

export const Tracking = () => {
  const { id = '0' } = useParams<{ id: string }>();
  const { isLoading, data: order } = useOrderDetail(id);
  const tagStatus = order?.status;

  if (isLoading) {
    return (
      <Styles.Wrapper data-testid='skeleton-tracking'>
        <Card>
          <Flex direction='column' gap='$2'>
            <Skeleton height='$5' />
            <Divider variant='Line' />
            <Styles.SkeletonTracking />
          </Flex>
        </Card>
      </Styles.Wrapper>
    );
  }
  return (
    <Styles.Wrapper data-testid='tracking'>
      <CardBase>
        <Flex direction='column' gap='$4'>
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Acompanhe seu pedido
          </ResponsiveFloraTypography>
          <Divider variant='Line' />
          <TrackingSteps tagStatus={tagStatus ?? ''} />
        </Flex>
      </CardBase>
    </Styles.Wrapper>
  );
};
